module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--26.935635f2.png";